export enum ViewType {
  Grid = 'grid',
  Table = 'table',
  Combo = 'combo',
}

export const VIEW_TYPE_GRID = ViewType.Grid;
export const VIEW_TYPE_TABLE = ViewType.Table;
export const VIEW_TYPE_COMBO = ViewType.Combo;
